<template>
    <div class="view view-checkout">
        <top-bar v-if="isPortalReady"/>
        <div class="site-content" v-show="isVisible">
            <div class="container">
                <div class="row">
                    <div
                        :class="(typeof this.$route.query.operador === 'undefined') ? 'col-md-6' : 'col-md-12'"
                        :style="{
                                'max-width':(typeof this.$route.query.operador !== 'undefined') ? '500px' : '',
                                'margin':(typeof this.$route.query.operador !== 'undefined') ? 'auto' : ''
                                }"
                     >
                        <div
                            class="checkout-card checkbox checkbox-aqua"
                            :class="{'checkbox-checked': curso.id == productoSeleccionado }"
                            @click="seleccionar_producto(curso.id)"
                         >


                            <div class="checkout-card-image">
                                <img
                                    :src="require('@/assets/galerias/foto_generica.jpg')"
                                    alt
                                />
                            </div>
                            <div class="checkout-card-info">
                                <div class="d-flex justify-content-between">
                                    <div v-if="this.$route.params.suscripcion!='suscripcion'">
                                        <div class="checkout-card-titulo">{{ categoria.categoria }}</div>
                                        <div class="checkout-card-autor">{{ categoria.autor }}</div>
                                    </div>

                                    <div v-else>
                                        <div class="checkout-card-titulo">{{ curso.producto }}</div>
                                        <div class="checkout-card-autor">{{ curso.producto }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <header v-if="this.$route.params.suscripcion=='suscripcion'" class="curso-clases-header transparente-borde" >
                            <div class="curso-clases-descripcion text-justify texto">
                                <h3 class="curso-clases-titulo-contenido">¿Qué aprenderás en este curso?</h3>
                                <div class="texto" v-html="this.portal.descripcion"></div>
                            </div>
                        </header>
                    </div>
                        <div class="row mb-30"
                            v-if="typeof this.$route.query.operador === 'undefined' && selectedPortalPasarela && selectedPortalPasarela.pasarela && selectedPortalPasarela.pasarela.is_movil<1"
                         >
                    </div>
                </div>

                <block-static destacado="checkout"/>
            </div>
        </div>

        <site-footer v-if="isPortalReady" :verFooter="true"/>
        <b-modal v-model="isMovilModalVisible" :busy="true" centered title="Suscribir" hide-footer>
            <div class="form">
                <div class="form-group">
                    <input v-model="telefono_suscribir"
                           class="form-control text-center"
                           type="text"
                           maxlength="12"
                           placeholder="Ingrese numero de telefono"
                           ref="telefono_suscribir"/>
                </div>
                <div class="form-group d-flex justify-content-center">
                    <button class="btn btn-primary btn-noradius" @click="openConfirmUser">
                        Confirmar Suscripción
                        <spinner v-if="isLoadingPagoMovilUrl" class-name="color-white"/>
                    </button>
                </div>
                <label class="checkbox-inline mr-4">

                </label>
                <div
                    class="text-center alert-text-box"
                    :class="{
                         'color-red': !colorMensajeMovil ,
                         'color-green': colorMensajeMovil
                         }"
                    v-if="movilMessage != ''"
                >{{ movilMessage }}
                </div>
            </div>
        </b-modal>

        <b-modal v-model="isPinModalVisible"
                 :busy="true"
                 centered
                 title="SOLICITUD DE PIN AUTENTICACIÓN"
                 hide-footer
        >
            <div class="form">
                <div class="form-group">
                    <label>Ingrese el codigo PIN que llegara a su telefono</label>
                    <input
                        v-model="pin"
                        class="form-control text-center"
                        type="text"
                        maxlength="12"
                        placeholder="Codigo PIN"
                        ref="pin"
                    />
                </div>
                <div class="form-group d-flex justify-content-center">
                    <button class="btn btn-primary btn-noradius" @click="PagoMovilPin">
                        Confirmar Suscripción
                        <spinner v-if="isLoadingPagoMovilPinUrl" class-name="color-white"/>
                    </button>
                </div>
                <div
                    class="text-center alert-text-box"
                    :class="{
                         'color-red': !colorMensajePin ,
                         'color-green': colorMensajePin
                         }"
                    v-if="pinMessage != ''"
                >{{ pinMessage }}
                </div>
            </div>
        </b-modal>
        <b-modal v-model="isPagoModalVisible" :busy="true" centered hide-footer title="Procesando Pago">
            <div class="form-group text-center">
                Esperando pago
                <spinner/>
                <br/>
                <a
                    v-if="urlPasarela"
                    :href="urlPasarela"
                    class="btn btn-primary btn-noradius"
                >ABRIR PASARELA DE PAGO</a>
            </div>
        </b-modal>

        <b-modal v-model="modalInitMovistarHeader"
                 :busy="true"
                 centered
                 hide-footer
                 v-bind:title="curso.producto + ' Valor ' + formatCurrency(selectedPortalPasarela.pasarela.precio) + ' Semanal '  ">
            <div class="form-group text-center">
                <div class="checkout-card-image">
                    <img
                        :src="require('@/assets/galerias/foto_generica.jpg')"
                        alt
                    />
                </div>
                <br>
                <label class="label-movistar">Para mi número</label>
                <br>
                <label class="label-num-tele"><b>+{{msisdnEntel}}</b></label>
                <br>
                <label class="label-movistar">Cobro recurrente con <b>cargo a mi boleta</b> o <b>saldo Movistar</b></label>
                <br>
                <br/>
                <div class="row">
                    <div class="col">
                        <button v-if="msisdnEntel!='Espere por favor' && msisdnEntel!=''"
                            :class="'btn btn-primary-aceptar checkout-pay '"
                            @click="openConfirmUser"
                            style="border-radius: 8px"
                            >
                            ACEPTO <br>
                            <u class="tyc">Terminos y Condiciones</u>
                        </button>
                        <br>
                        <br>
                        <button v-if="msisdnEntel!='Espere por favor' && msisdnEntel!=''"
                                :class="'btn btn-primary checkout-pay btn-cancel label-movistar-cancelar'"
                                @click="volverCancelarSalir"
                                style="border-radius: 8px">
                            CANCELAR / VOLVER
                        </button>
                        <br>
                        <label class="label-movistar">Completa la contratación en la página siguiente</label>
                        <div v-if="errorMessage != ''">
                            <div class="alert-text-box checkout-error-message">{{ errorMessage }}</div>

                            <div
                                class="text-center alert-text-box"
                                :class="{
                                                'color-red': !colorMensajeMovil ,
                                                'color-green': colorMensajeMovil
                                                }"
                                v-if="movilMessage != ''"
                            >{{ movilMessage }}
                            </div>
                        </div>
                    </div>
                </div>
                    <label class="label-movistar"><b>RECUERDA:</b></label>
                    <div>
                        <ul>
                            <li>Puedes darte de baja en cualquier momento unviando un <b>SMS</b> con <b>el texto SALIR al 7600 sin costo</b></li>
                            <li>El precio incluye IVA</li>
                            <li>Puedes revisar los <a href="/pagina/terminos-y-condiciones_1" target="_blank" class="tyc"><u><b>Términos y Condiciones</b></u></a></li>
                        </ul>
                    </div>
            </div>
        </b-modal>

        <!--Modal para confirmar si en realidad quiere confirmar la compra del curso-->
        <b-modal v-model="confirm_of_user"
                 :busy="true"
                 centered
                 hide-footer
                 v-bind:title="curso.producto + ' Valor ' + formatCurrency(selectedPortalPasarela.pasarela.precio) + ' Semanal '  "
                 style="font-weight: normal">
            <div class="form-group text-center">
                <div class="checkout-card-image">
                    <img
                        :src="require('@/assets/galerias/foto_generica.jpg')"
                        alt
                    />
                </div>
                <br>
                <div class="row">
                 <div class="col">
                    <button
                        :class="'btn btn-primary checkout-pay'"
                        @click="pagar"
                        style="border-radius: 8px">
                        <b>SUSCRIBIRME</b>
                    </button>
                </div>
            </div>
            <br>
            <div class="form-group text-center">
                <label class="label-movistar">Al <b>SUSCRIBIR</b> estoy aceptando el cobro recurrente con <b>cargo a mi boleta</b> o <b>saldo Movistar</b></label>
                <br>
                <label class="label-movistar">Para mi número</label>
                <br>
                <label class="label-num-tele"><b>+{{msisdnEntel}}</b></label>
                <br>
                <button v-if="msisdnEntel!='Espere por favor' && msisdnEntel!=''"
                        :class="'btn btn-primary checkout-pay btn-cancel label-movistar-cancelar'"
                        @click="volverCancelarSalir"
                        style="border-radius: 8px">
                    SALIR / VOLVER
                </button>
            </div>
            <label class="label-movistar"><b>RECUERDA:</b></label>
            <div>
                <ul>
                    <li>Puedes darte de baja en cualquier momento unviando un <b>SMS</b> con <b>el texto SALIR al 7600 sin costo</b></li>
                    <li>El precio incluye IVA</li>
                    <li>Puedes revisar los <a href="/pagina/terminos-y-condiciones_1" target="_blank"><u><b>Términos y Condiciones</b></u></a></li>
                </ul>
            </div>
        </div>
        </b-modal>

                <b-modal v-model="isPagoModalVisible" :busy="true" centered hide-footer title="Procesando Pago">
            <div class="form-group text-center">
                Esperando pago
                <spinner/>
                <br/>
                <a
                    v-if="urlPasarela"
                    :href="urlPasarela"
                    class="btn btn-primary btn-noradius"
                >ABRIR PASARELA DE PAGO</a>
            </div>
        </b-modal>

        <!--Modal si no es reconocida la ip por la red-->
        <b-modal v-model="modalPinInputMsisdn"
                 :busy="true"
                 centered
                 hide-footer
                 v-bind:title="curso.producto + ' Valor ' + formatCurrency(selectedPortalPasarela.pasarela.precio) + ' Semanal '  ">
            <div class="form-group text-center">
                <div class="checkout-card-image">
                    <img
                        :src="require('@/assets/galerias/foto_generica.jpg')"
                        alt
                    />
                </div>
                <br>
                <div class="form-group">
                    <label>Para mi número</label>
                    <input
                        type="number"
                        :class="{
                                                 'center-input': true,
                                                'form-control': true,
                                'is-invalid': validated && (telefono == '' || !isTelefonoValid),
                                'is-valid': validated && isTelefonoValid && telefono != ''
                                                }"
                        name="email"
                        id="registro-form-telefono-landing-new"
                        aria-describedby="telefonoHelp"
                        placeholder="Número de teléfono Ej: 912345678"
                        autocomplete="off"
                        v-model="telefono"
                        required
                    />
                    <div class="invalid-feedback">Teléfono inválido</div>
                    <div class="valid-feedback" v-if="validated && telefono != user.telefono"></div>
                </div>
                <br>
                <label class="label-movistar">Cobro recurrente con <b>cargo a mi boleta</b> o <b>saldo Movistar</b></label>
                <br>
                <!--                <div class="checkout-card-image">
                                    <img
                                        :src="(curso.foto_principal.includes('/fl_lossy/')) ? curso.foto_principal : curso.foto_principal.replace('upload', 'upload/fl_lossy').replace('http:', 'https:')"
                                        alt
                                    />
                                </div>-->
                <div class="row">
                    <div class="col">
                        <button
                                :class="'btn btn-primary-aceptar checkout-pay '"
                                @click="submitTelefono"
                                style="border-radius: 8px"
                        >
                            ACEPTO <br>
                            <u class="tyc">Terminos y Condiciones</u>
                        </button>
                        <br>
                        <br>
                        <button
                                :class="'btn btn-primary checkout-pay btn-cancel label-movistar-cancelar'"
                                @click="volverCancelarSalir"
                                style="border-radius: 8px">
                            CANCELAR / VOLVER
                        </button>
                        <br>
                        <label class="label-movistar">Completa la contratación en la página siguiente</label>
                        <div v-if="errorMessage != ''">
                            <div class="alert-text-box checkout-error-message">{{ errorMessage }}</div>

                            <div
                                class="text-center alert-text-box"
                                :class="{
                                                'color-red': !colorMensajeMovil ,
                                                'color-green': colorMensajeMovil
                                                }"
                                v-if="movilMessage != ''"
                            >{{ movilMessage }}
                            </div>
                        </div>
                    </div>
                </div>
                <label class="label-movistar"><b>RECUERDA:</b></label>
                <div>
                    <ul>
                        <li>Puedes darte de baja en cualquier momento unviando un <b>SMS</b> con <b>el texto SALIR al 7600 sin costo</b></li>
                        <li>El precio incluye IVA</li>
                        <li>Puedes revisar los <a href="/pagina/terminos-y-condiciones_1" target="_blank"><u><b>Términos y Condiciones</b></u></a></li>
                    </ul>
                </div>
            </div>
        </b-modal>

         <b-modal v-model="modalPinInputPin"
                 :busy="true"
                 centered
                 hide-footer
                  v-bind:title="curso.producto + ' Valor ' + formatCurrency(selectedPortalPasarela.pasarela.precio) + ' Semanal '  ">
            <div class="form-group text-center">
                <div class="checkout-card-image">
                    <img
                        :src="require('@/assets/galerias/foto_generica.jpg')"
                        alt
                    />
                </div>
                <br>
                <label class="label-movistar">Te enviamos un mensaje <b>SMS a tu número +{{telefono}}</b> con un <b>Código PIN</b> para que puedas confirmar tu suscripción</label>
                <br>
                <label class="label-movistar"></label>
                <div class="row">
                <div class="form form-input">
                <div class="form-group">
<!--                    <label>Ingrese el codigo PIN que llegara a su telefono</label>-->
                    <input
                        v-model="pin"
                        class="form-control text-center center-input"
                        type="text"
                        maxlength="12"
                        placeholder="Ingresar Código PIN"
                        ref="pin"
                    />
                </div>
                    <label class="label-movistar">Al <b>SUSCRIBIR</b> estoy aceptando el cobro recurrente con <b>cargo a mi boleta</b> o <b>saldo Movistar</b></label>
                    <br>
                    <div class="col">
                    <button
                        :class="'btn btn-primary checkout-pay '"
                        style="border-radius: 8px"
                        @click="PagoMovilPin">
                        <b style="color: white">SUSCRIBIRME</b>
                    </button>
                    <br>
                    <br>
                    <button
                        :class="'btn btn-primary checkout-pay btn-cancel label-movistar-cancelar'"
                        @click="volverCancelarSalir"
                        style="border-radius: 8px">
                        SALIR / VOLVER
                    </button>
                </div>
                <div
                    class="text-center alert-text-box"
                    :class="{
                         'color-red': !colorMensajePin ,
                         'color-green': colorMensajePin
                         }"
                    v-if="pinMessage != ''"
                >{{ pinMessage }}
                </div>
            </div>
                </div>
                <label class="label-movistar"><b>RECUERDA:</b></label>
                <div>
                    <ul>
                        <li>Puedes darte de baja en cualquier momento unviando un <b>SMS</b> con <b>el texto SALIR al 7600 sin costo</b></li>
                        <li>El precio incluye IVA</li>
                        <li>Puedes revisar los <a href="/pagina/terminos-y-condiciones_1" target="_blank"><u><b>Términos y Condiciones</b></u></a></li>
                    </ul>
                </div>
            </div>
        </b-modal>

       <!--Modal final de registro de Movistar-->
        <b-modal v-model="suscrib_felicitaciones"
                 :busy="true"
                 centered
                 hide-footer
                 v-bind:title="curso.producto + ' Valor ' + formatCurrency(selectedPortalPasarela.pasarela.precio) + ' Semanal '  "
                 style="font-weight: normal">
            <div class="form-group text-center">
                <div class="checkout-card-image">
                    <img
                        :src="require('@/assets/galerias/foto_generica.jpg')"
                        alt
                    />
                </div>
                <br>
                <label class="label-movistar" style="font-size: 17px">Desde ahora recibiras el cobro recurrente con <b>cargo a tu boleta</b> o <b>saldo Movistar</b></label>
                <br>
                <label class="label-movistar">Para tu número</label>
                <br>
                <label class="label-num-tele"><b>+{{telefono}}</b></label>
                <br>
                <label class="label-movistar" style="font-size: 2em">Felicitaciones ya puedes disfrutar del {{curso.producto}}</label>
                <br>
                <br>
                <div class="row">
                    <div class="col">
                        <button
                            :class="'btn checkout-pay '"
                            style="background-color: #24CCC0; border-radius: 8px;"
                            @click="accederServicio">
                            <b style="color: white">ACCEDER/DESC APP</b>
                        </button>
                    </div>
                </div>
                <br>
                <label class="label-movistar"><b>RECUERDA:</b></label>
                <div>
                    <ul>
                        <li>Puedes darte de baja en cualquier momento unviando un <b>SMS</b> con <b>el texto SALIR al 7600 sin costo</b></li>
                        <li>El precio incluye IVA</li>
                        <li>Puedes revisar los <a href="/pagina/terminos-y-condiciones_1" target="_blank"><u><b>Términos y Condiciones</b></u></a></li>
                    </ul>
                </div>
            </div>

        </b-modal>
               <!--Modal final de error Movistar-->
        <b-modal v-model="movistar_error_modal"
                 :busy="true"
                 centered
                 hide-footer
                 title="No fue posible finalizar la suscripción"
                 style="font-weight: normal">
            <div class="form-group text-center">
                <label class="label-movistar" style="font-size: 2em">{{curso.producto}}</label>
                <br>
                <label class="label-movistar">Por favor inicia proceso nuevamente</label>
                <br>
                <div class="row">
                    <div class="col">
                        <button
                            :class="'btn checkout-pay '"
                            style="background-color: #24CCC0;"
                            @click="modalPinInputMsisdn=true">
                            <b>Reintentar</b>
                        </button>
                    </div>
                </div>
                <br>
                <label class="label-movistar">Recuerda que su cobro se realizará a través de tu Número Movistar</label>
                <br>
                <label class="label-movistar">+{{msisdnEntel}}</label>
                <br>
                <label class="label1-movistar">Puedes dar la <b>baja</b> del servicio en cualquier momento enviando la palabra <b>SALIR al Número 7600</b> vía Mensaje de Texto (SMS)</label>
                <br>
            </div>
        </b-modal>

        <b-modal v-model="isPagoUrlLandingModalVisible"
                 :busy="true"
                 centered
                 hide-footer
                 title="Notificación"
        >
            <div class="text-center alert-text-box">
                <p v-if="this.isPagoLandingMessage==''">
                    Iniciando
                    <spinner class-name="color-red"/>
                </p>
                <p v-if="this.isPagoLandingMessage!=''">{{ this.isPagoLandingMessage }}</p>
            </div>
        </b-modal>
    </div>
</template>

<script>
import {mapState, mapGetters} from "vuex";
import bModal from "bootstrap-vue/es/components/modal/modal";
import bModalDirective from "bootstrap-vue/es/directives/modal/modal";
import TopBar from "../components/TopBar";
import Spinner from "../components/Spinner";
import {isValidEmail, isValidTelefono, rutEsValido} from "../utilities/util";
import BlockStatic from "../components/BlockStatic";
import {
    getCategoriaDeProducto,
    getProducto,
    userTieneProducto,
} from "../utilities/data";
import numeral from "numeral";
import "numeral/locales";
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";

numeral.locale("es");

export default {
    name: "checkout",
    components: {
        TopBar,
        bModal,
        Spinner,
        BlockStatic,
        FontAwesomeIcon,
    },
    directives: {
        "b-modal": bModalDirective,
    },
    head: {
        title() {
            return {
                inner: this.curso.producto,
            };
        },
    },
    computed: {
        isTelefonoValid() {
            return isValidTelefono(this.telefono.toString());
        },
        curso() {
            return this.portal.productos_portal
                ? getProducto(this.portal, this.$route.params.id)
                : {};
        },
        // pasarelasNoMoviles() {
        //     return this.portalPasarelas.filter((pasarela) => pasarela.is_movil == 0);
        // },
        // pasarelasMoviles() {
        //     return this.portalPasarelas.filter((pasarela) => pasarela.is_movil == 1);
        // },
        categoria() {
            return getCategoriaDeProducto(this.portal, this.curso.id);
        },
        producto() {
            return this.portal.productos_portal.find(
                (p) => p.id == this.$route.params.id
            );
        },
        ...mapState(["portal", "user", "site", "isPortalReady"]),
        ...mapGetters(["userId"]),
    },
    watch: {
        portal(val, old) {
            if (val) {
                if (typeof val.productos_portal !== "undefined") {
                    //Comento segundo llamado de start para evitar llamados adicionales en los landings
                    //this.start();
                }
            }
        },
        selectedPortalPasarela(val, old) {
            if (val.pasarela.pasarela == "Movistar") {
                //this.movistarIP();
            }
        },
    },
    data() {
        return {
            confirm_of_user: false,
            suscrib_felicitaciones: false,
            movistar_error_modal: false,
            test: null,
            counterestado: 0,
            mensajeRegalo: null,
            selectedPortalPasarela: {},
            isVisible: false,
            portalPasarelas: [],
            isLoadingPagoUrl: false,
            isLoadingPagoMovilUrl: false,
            isLoadingPagoMovilPinUrl: false,
            isCencosudRutModalVisible: false,
            CheckCencosudRut: false,
            validRutCencosud: false,
            rut: "",
            productoSeleccionado: this.$route.params.id,
            id_descuento: null,
            url_cencosud: "",
            codigo_descuento: null,
            descuento: {},
            email_share: null,
            name_share: null,
            fecha_entrega_share: null,
            mensaje_entrega_share: null,
            id_user_share: null,
            descuentoMessage: "",
            movilMessage: "",
            pinMessage: "",
            id_compra: 0,
            isTransferenciaModalVisible: false,
            isCencosudModalVisible: false,
            isDescuentoModalVisible: false,
            isMovilModalVisible: false,
            isPinModalVisible: false,
            modalInitMovistarHeader: false,
            modalPinInputMsisdn: false,
            modalPinInputPin: false,
            isPagoModalVisible: false,
            isRegaloModalVisible: false,
            colorMensajeDescuento: false,
            colorMensajeMovil: false,
            colorMensajePin: false,
            showInputDescuento: true,
            isRegaloValidated: false,
            isPagoUrlLandingModalVisible: false,
            errorMessage: "",
            mensajeDescuentoAplicado: "",
            montoTotal: 0,
            telefono_suscribir: "",
            header: false,
            pin: "",
            urlPin: "",
            urlPasarela: "",
            msisdnEntel: "",
            operadorParametro: "",
            service_ip_entel: false,
            service_ip_wom: false,

            telefono: "",
            validated: false,
            cuentaCreada: false,
            activarCuentaCheckout: 0,
            isSubmitting: false,
            alert: {
                message: "",
                visible: false,
                icon: "",
                iconSpin: false,
            },
            isPagoLandingMessage: "",
            operador_suscribir: "",
            isBancoEstadoRutModalVisible: false,
            isValidRutBancoEstado: false,
            rutBancoEstado: "",

            mensajes: {
                "METODO PAGO INVALIDO": "Por favor escoge otro medio de pago.",
                "COMPRA NO ENCONTRADA": "Compra inválida.",
                "EL PRODUCTO YA SE ENCUENTRA DISPONIBLE": "Ya tienes este producto.",
                "PARAMETROS VACIOS": "Por favor coloca todos los datos requeridos.",
                "PARAMETROS REQUERIDOS": "Por favor coloca todos los datos requeridos.",
                "ERROR TOKEN INVALIDO":
                    "Error procesando la compra, por favor intenta de nuevo.",
                ERROR: "Error procesando la compra, por favor intenta de nuevo.",
                "ALTA EXISTE":
                    "Error el numero de telefono se encuentra dado alta con este servicio",
                "OPERADOR INVALIDO":
                    "El numero de telefono no corresponde con el operador seleccionado",
                "TELEFONO VACIO, INVALIDO O FALTAN PARAMETROS":
                    "Error procesando la compra, por favor intenta de nuevo.",
                "El movil no tiene saldo.": "El movil no tiene saldo.",
                "Fallo en configuracion de validacion.":
                    "Fallo en configuracion de validacion.",
                "El movil ya esta agendado.": "El movil ya esta agendado.",
                "El plan no se encuentra registrado":
                    "El plan no se encuentra registrado",
                "IP no autorizada.": "IP no autorizada.",
                "Contenido no valido.": "Contenido no valido.",
                "Entrada no valida.": "Entrada no valida.",
                "Suscripcion Fallida.": "Suscripcion Fallida.",
                "Cobro Fallido.": "Cobro Fallido.",
                "Error Interno.": "Cobro Fallido.",
                "El movil debe pertenecer a EPCS.": "El movil debe pertenecer a EPCS.",
                "El movil no es compatible.": "El movil no es compatible.",
                "El movil esta en roaming.": "El movil esta en roaming.",
                "El movil tiene bloqueado el servicio.":
                    "El movil tiene bloqueado el servicio.",
                "Solicitud no valida.": "Solicitud no valida.",
                "El movil no tiene perfil compatible":
                    "El movil no tiene perfil compatible",
                "El proveedor ha alcanzado el límite Diario y Mensual de suscripciones":
                    "El proveedor ha alcanzado el límite Diario y Mensual de suscripciones",
                "El proveedor ha alcanzado el límite Diario de suscripciones":
                    "El proveedor ha alcanzado el límite Diario de suscripciones",
                "El proveedor ha alcanzado el límite Mensual de suscripciones":
                    "El proveedor ha alcanzado el límite Mensual de suscripciones",
                "El movil no posee tokens": "El movil no posee tokens",
                "La url al servicio segmentate no esta disponible":
                    "La url al servicio segmentate no esta disponible",
                "El pin ingresado es incorrecto": "El pin ingresado es incorrecto",
                "Error al suscribir al movil": "Error al suscribir al movil",
                "CREDITOS INSUFICIENTES": "Error los créditos son insuficientes",
            },
        };
    },
    methods: {
        formatCurrency(amount) {
            return numeral(amount).format("$0,0");
        },
        setPortalPasarela(portalPasarela, event) {

            this.$log.warn('eligiendo metodo de pago')
            if (portalPasarela.pasarela.visible) {

                this.selectedPortalPasarela = portalPasarela;

                //SELECCIONAR MEOTOD PAGO
                dataLayer.push({
                    event: "checkoutOption",
                    ecommerce: {
                        checkout_option: {
                            actionField: {
                                step: 2,
                                option: portalPasarela.pasarela.pasarela,
                            },
                        },
                    },
                });

                //intentar la identificacion solo si el usuario no introdujo el numero
                if (this.telefono !== "") {
                    return false;
                }
                this.isPagoUrlLandingModalVisible = true;
                switch (portalPasarela.pasarela.pasarela) {

                    case "Movistar":
                        this.movistarIP();
                        break;
                }
            } else {
                event.preventDefault();
                return false;
            }
        },
        cargar_pasarela(id_product) {
            if (
                this.portal.productos_portal.filter(
                    (producto) => producto.id == id_product
                ).length > 0
            ) {
                // Cargar pasarelas del producto/portal
                this.portalPasarelas = this.portal.productos_portal
                    .filter((producto) => producto.id == id_product)[0]
                    .productos_pasarelas.map((pp) => {
                        return {
                            id_portal_pasarela: pp.id_portal_pasarela,
                            pasarela: pp.productos_portal_pasarela[0].pasarelas[0],
                        };
                    });

                if (this.portalPasarelas.length > 0 && this.msisdnEntel == "") {
                    //Si el query route posee operador se selecciona una pasarela de operadores
                    if (typeof this.$route.query.operador !== "undefined") {

                        let firstPasarelaMovil = this.portalPasarelas.find(({pasarela}) => {
                            //Encontrar pasarela movil
                            if (pasarela.is_movil) {
                                return pasarela;
                            }
                        });

                        if (typeof firstPasarelaMovil !== "undefined") {
                            this.selectedPortalPasarela = firstPasarelaMovil
                        } else {
                            this.selectedPortalPasarela = this.portalPasarelas[0];
                        }

                    } else {
                        this.selectedPortalPasarela = this.portalPasarelas[0];
                    }
                }

                //SELECCIONAR MEOTOD PAGO
                dataLayer.push({
                    event: "checkoutOption",
                    ecommerce: {
                        checkout_option: {
                            actionField: {
                                step: 2,
                                option: this.selectedPortalPasarela.pasarela.pasarela,
                            },
                        },
                    },
                });
            } else {
                // El id del curso no existe.
                this.$router.replace({name: "error404"});
            }
        },

        PagoMovilPin() {

            this.$log.warn('Estamos en  PagoMovilPin');
            this.isLoadingPagoMovilPinUrl = true;

            //console.log("QUERY operador", this.$route.query.operador);
            //Si es operador entel y esta en un landing se hace flujo de landings preworks
            if ((this.selectedPortalPasarela.pasarela.pasarela.toLowerCase() == "movistar") &&
                typeof this.$route.query.operador !== "undefined") {
                /* Se evita toda la logica realizada hasta ahora (Registro -- Login y pago) y se encamina al usuario al flujo necesario (Landing Pre-work)*/
                this.LandingsPreWorks(this.pin);
            } else {
                this.$log.warn('aca esta el else de pago movil pin ');

                this.movistar_error_modal = true;

            }
        },

        PagoMovil() {
            this.$log.warn('pasamos a PagoMovil ');
            if (this.user.id == 0) {
                this.$log.warn('his.user.idl ')
                //this.$store.commit("togglePortalRegistroModal", true);
                return false;
            }
            this.isLoadingPagoMovilUrl = true;
            this.$log.warn('PagoMovil 1')
            // Es pago con postback
            this.$api.getPagoUrl({
                    id_producto:
                        this.productoSeleccionado == false
                            ? this.$route.params.id
                            : this.productoSeleccionado,
                    id_portal_pasarela: this.selectedPortalPasarela.id_portal_pasarela,
                    id_moneda: this.selectedPortalPasarela.pasarela.monedas[0].id,
                    id_descuento: this.id_descuento,
                    id_user_share: this.id_user_share,
                    total: this.producto.precio,
                    fecha_entrega: this.fecha_entrega_share,
                    mensaje_entrega: this.mensaje_entrega_share,
                    network:
                        Object.getOwnPropertyNames(this.$route.query).length > 0
                            ? this.$route.query
                            : "",
                    utm_source: localStorage.getItem("utm_source"),
                    utm_medium: localStorage.getItem("utm_medium"),
                    utm_campaign: localStorage.getItem("utm_campaign"),
                    deviceName:"Huawei",
                    deviceId:this.user.id,
                    idProduct:this.producto.movistar_id_producto,
                    header:
                        this.selectedPortalPasarela.pasarela.pasarela == "Movistar" ||
                        this.msisdnEntel != ""
                            ? this.header
                            : "",
                    msisdn: this.telefono_suscribir,
                })
                .then((response) => {
                    this.$log.warn('PagoMovil response');
                    this.$log.warn(response);
                    //console.log("RESPUESTA PAGO MOVIL", response);
                    this.isLoadingPagoMovilUrl = false;
                    this.isLoadingPagoUrl = false;

                    if ("message" in response.data) {
                        if (response.data.message in this.mensajes) {
                            this.movilMessage = this.mensajes[response.data.message];
                            if (!this.isMovilModalVisible && this.movilMessage != "") {
                                this.isMovilModalVisible = true;
                            }
                            return false;
                        }
                        this.colorMensajeMovil = false;
                        if (!this.isMovilModalVisible && this.movilMessage != "") {
                            this.isMovilModalVisible = true;
                        }
                        return false;
                    }

                    if (typeof response.data.response.response !== "undefined" &&
                                            response.data.response.response == "400") {

                        this.movilMessage = response.data.response.message;
this.$log.warn('2PagoMovil response');
                        if (response.data.response.message in this.mensajes) {
                            this.movilMessage = this.mensajes[response.data.response.message];
                            if (!this.isMovilModalVisible && this.movilMessage != "") {
                                this.isMovilModalVisible = true;

                            }

                            return false;
                        }
                        this.colorMensajeMovil = false;
                        if (!this.isMovilModalVisible && this.movilMessage != "") {
                            this.isMovilModalVisible = true;

                        }
                        this.$log.warn('1PagoMovil response');
                        return false;
                    }

                    dataLayer.push({
                        event: "boton-pagar",
                    });

                    this.id_compra = response.data.id_compra;

                    //localStorage.removeItem("utm_source");
                    //localStorage.removeItem("utm_medium");
                    localStorage.removeItem("telefono_suscribir");
                    localStorage.removeItem("header");

                    //CASO MOVISTAR
                    if (this.selectedPortalPasarela.pasarela.pasarela.toLowerCase() =="movistar" ) {
                        if (response.data.response.includes("aprobado")) {
                            //CHECKOUT
                            dataLayer.push({
                                event: "checkout",
                                ecommerce: {
                                    checkout: {
                                        actionField: {step: 3, option: ""},
                                        products: [
                                            {
                                                name: this.producto.producto,
                                                id: this.producto.id,
                                                price: this.producto.precio,
                                                category: this.categoria.categoria,
                                                quantity: 1,
                                            },
                                        ],
                                    },
                                },
                            });

                            window.location = response.data.response;
                        } else if (response.data.response.includes("store")) {
                            //CHECKOUT
                            // dataLayer.push({
                            //     event: "checkout",
                            //     ecommerce: {
                            //         checkout: {
                            //             actionField: {step: 3, option: ""},
                            //             products: [
                            //                 {
                            //                     name: this.producto.producto,
                            //                     id: this.producto.id,
                            //                     price: this.producto.precio,
                            //                     category: this.categoria.categoria,
                            //                     quantity: 1,
                            //                 },
                            //             ],
                            //         },
                            //     },
                            // });

                            window.location = response.data.response;
                        } else {
                            this.$log.warn('else PagoMovil response');
                            this.isMovilModalVisible = false;
                            this.isPinModalVisible = true;
                            this.urlPin = response.data.response;
                        }
                    }
                });

                this.$log.warn('termina PagoMovil response');
        },
        pagar() {

            this.$log.warn('dentro de pagar')

            if (this.user.id == 0) {

                this.$log.warn('dentro de pagar1')
                if (typeof this.$route.query.operador !== "undefined" &&
                     localStorage.getItem("telefono_suscribir").length >= 9) {

                    this.$log.warn('dentro de pagar2')
                    //alert(localStorage.getItem("telefono_suscribir"));
                    this.submitTelefono(localStorage.getItem("telefono_suscribir"));
                }
            }

            this.$log.warn('dentro de pagar6')
            this.isLoadingPagoUrl = true;

            if (this.selectedPortalPasarela.pasarela.is_movil) {

                this.$log.warn('dentro de pagar7')
                        //COMENTADO SOLO PARA QUE PASE DIRECTO SIN EPDIR PIN
                localStorage.setItem("header", true);
                this.$log.warn('dentro de pagar10')
                this.header = localStorage.getItem("header");

                if (localStorage.getItem("telefono_suscribir").length >= 9) {
                    this.telefono_suscribir = localStorage.getItem("telefono_suscribir");
                }

                if (typeof this.$route.query.operador !== "undefined" &&
                    this.$route.query.operador == this.selectedPortalPasarela.pasarela.pasarela.toLowerCase() &&
                    this.telefono_suscribir != "") {

                    this.$log.warn('dentro de pagar11')
                    this.PagoMovil();

                } else if (this.header && this.telefono_suscribir != "") {
                    this.$log.warn('dentro de pagar12')
                    this.PagoMovil();
                } else {
                    this.$log.warn('dentro de pagar13')
                    this.telefono_suscribir = this.user.telefono;
                    this.isMovilModalVisible = true;
                    this.isLoadingPagoUrl = false;
                }
            } else {
                // Es pago con postback
                this.$api
                    .getPagoUrl({
                        id_producto:
                            this.productoSeleccionado == false
                                ? this.$route.params.id
                                : this.productoSeleccionado,
                        id_portal_pasarela: this.selectedPortalPasarela.id_portal_pasarela,
                        id_moneda: this.selectedPortalPasarela.pasarela.monedas[0].id,
                        id_descuento: this.id_descuento,
                        id_user_share: this.id_user_share,
                        total: this.producto.precio,
                        rut: toSendRutPagoUrl,
                        fecha_entrega: this.fecha_entrega_share,
                        mensaje_entrega: this.mensaje_entrega_share,
                        network:
                            Object.getOwnPropertyNames(this.$route.query).length > 0
                                ? this.$route.query
                                : "",
                        utm_source: localStorage.getItem("utm_source"),
                        utm_medium: localStorage.getItem("utm_medium"),
                        utm_campaign: localStorage.getItem("utm_campaign"),
                    })
                    .then((response) => {
                        this.isLoadingPagoUrl = false;

                        if ("message" in response.data) {
                            if (response.data.message in this.mensajes) {
                                this.errorMessage = this.mensajes[response.data.message];
                                return false;
                            }
                            return false;
                        }

                        this.errorMessage = "";
                        this.id_compra = response.data.id_compra;
                        this.url_cencosud = response.data.url_cencosud;

                        //localStorage.removeItem("utm_source");
                        //localStorage.removeItem("utm_medium");
                        localStorage.removeItem("telefono_suscribir");
                        localStorage.removeItem("header");

                        dataLayer.push({
                            event: "boton-pagar",
                        });

                    });
            }
            this.$log.warn('dentro de pagar14')
        },
        async submitTelefono(telf) {

            let isUserHeader = localStorage.getItem("header");

            if (isUserHeader == "true") {
                this.$log.warn("Inicia flujo header para linea")
                 this.isPagoUrlLandingModalVisible = true;
                 //flujo prework . aca vamos al cms
                 this.LandingsPreWorks(this.pin);
                 this.$log.warn("termina flujo header");
            return;

            } else {
                this.$log.warn("Es flujo PIN");
                this.$log.warn("telefono:", this.telefono);
                localStorage.setItem("telefono_suscribir", this.telefono);

                var operador_movil = "";
                await this.$api.operador({telefono: this.telefono}).then((response) => {
                    this.$log.warn(response)
                    operador_movil = response.data
                        .replace("<response>", "")
                        .replace("</response>", "");
                    this.operador_suscribir = operador_movil.toLowerCase();
                    if (operador_movil == "Entel") {
                        fbq("track", "InitiateCheckout");
                    } else if (operador_movil == "Movistar") {
                       localStorage.setItem("isTelefonoValid", "true");
                    }
                });

                this.LandingsPreWorks();
                this.$log.warn("termina flujo presuscribir");
                return;

            }

            this.validated = true;
            let isValid = true;

            if (!this.isTelefonoValid && localStorage.getItem("header") == "false") {
                isValid = false;
            }

            if (!isValid) {
                return false;
            }
             //Si el telefono identificado es distinto de vacio y el telefono del imput no fue suministrado
            if (this.msisdnEntel != "" && this.telefono != "") {
                //El telefono a suscribir es el identificado por la red
                telf = this.msisdnEntel;
            } else {
                //El telefono a suscribir es el indicado en el imput
                telf = this.telefono;
            }

            let newUserData = {
                usuario: "",
                activarCuentaCheckout: 1,
                name: "",
                apellido: "",
                email: "",
                telefono: telf,
                direccion: "",
                termino_condicion: 1,
                password: "",
                sexo: "",
                fecha_nac: "",
                registro_telefono: 1,
                utm_source: localStorage.getItem("utm_source"),
                utm_medium: localStorage.getItem("utm_medium"),
                utm_campaign: localStorage.getItem("utm_campaign"),
            };

            if (isValid) {
                // var operador_movil = "";
                // await this.$api.operador({telefono: telf}).then((response) => {
                //     this.$log.warn(response)
                //     operador_movil = response.data
                //         .replace("<response>", "")
                //         .replace("</response>", "");
                //     this.operador_suscribir = operador_movil.toLowerCase();
                //     if (operador_movil == "Entel") {
                //         fbq("track", "InitiateCheckout");
                //     }
                // });

                this.isPagoUrlLandingModalVisible = true;

                if (
                    this.selectedPortalPasarela.pasarela.pasarela.toLowerCase() == "movistar" ||
                    this.selectedPortalPasarela.pasarela.pasarela.toLowerCase() == "entel"
                ) {
                    //Escribo numero de telefono en local storage
                    //localStorage.setItem("telefono_suscribir", telf);

                    //si el pin fue pre- identificado se envia a con el landing prework
                    if (this.pin != "") {
                        this.LandingsPreWorks(this.pin);
                    } else {
                        this.LandingsPreWorks();
                    }
                } else {
                    this.$store
                        .dispatch("registro", newUserData)
                        .then((response) => {
                            dataLayer.push({
                                event: "registro-creado",
                            });

                            dataLayer.push({
                                action: "" + operador_movil + "",
                                event: "registro-movil",
                            });

                            fbq("track", "CompleteRegistration");

                            if (this.$route.name == "checkout") {
                                if (this.telefono != "") {
                                    this.$store
                                        .dispatch("login", {
                                            telefono: telf,
                                            validarEntrada: "CHECKOUT",
                                        })
                                        .then((response) => {
                                            //document.querySelector("#pagar_curso").click();
                                            localStorage.setItem("telefono_suscribir", telf);
                                            this.pagar();
                                            this.$emit("loginSuccessful", response);
                                        })
                                        .catch((error) => {
                                            this.ButtonActivarEnvioCorreo = false;
                                            if (error == "USER INACTIVO") {
                                                this.ButtonActivarEnvioCorreo = true;
                                            }
                                            this.loginMessage = "Error al registrar, revise teléfono";
                                            this.loginMessageShow = true;
                                            this.$emit("loginError", error);
                                            this.isSubmitting = false;
                                        });
                                }
                            }
                        })
                        .catch((error) => {
                            if (this.telefono != "") {
                                this.$store
                                    .dispatch("login", {
                                        telefono: telf,
                                        validarEntrada: "CHECKOUT",
                                    })
                                    .then((response) => {
                                        //document.querySelector("#pagar_curso").click();
                                        localStorage.setItem("telefono_suscribir", telf);
                                        this.pagar();
                                        this.$emit("loginSuccessful", response);
                                    })
                                    .catch((error) => {
                                        this.ButtonActivarEnvioCorreo = false;
                                        if (error == "USER INACTIVO") {
                                            this.ButtonActivarEnvioCorreo = true;
                                        }
                                        this.isPagoLandingMessage = error;

                                        this.$emit("loginError", error);
                                        this.isSubmitting = false;
                                    });
                            }
                        });
                }
            }
        },
        estadoCompra(id_compra) {
            if (id_compra > 0) {
                let Data = {
                    id_compra: id_compra,
                };

                this.$api.estado_compra(Data).then((response) => {
                    //console.log("ESTADO COMPRA :", response.data.data);
                    if (response.data.data.estado_compra == "PAGADA") {
                        this.$router.push({
                            name: "CheckoutFinish",
                            params: {
                                pasarela: response.data.data.metodo_pago,
                                id_compra: response.data.data.id,
                                estado: "aprobado",
                            },
                        });
                    }

                    if (response.data.data.estado_compra == "RECHAZADA") {
                        this.$router.push({
                            name: "CheckoutFinish",
                            params: {
                                pasarela: response.data.data.metodo_pago,
                                id_compra: response.data.data.id,
                                estado: "rechazada",
                            },
                        });
                    }
                });
            }
        },

        async movistarIP() {
            /*LLAMMAR HEADER MOVISTAR */
            this.isPagoUrlLandingModalVisible = true;
            if (typeof this.$route.query.id === "undefined") {
                var thisinterno = this;
                this.isLoadingPagoUrl = true;
                this.service_ip_entel = true;

                let TOKEN = "";
                let DATA = "";
                this.$log.warn('antes de entrar a service_json_movistar_encode')
                await this.$api
                    .service_json_movistar_encode({post: null})
                    .then((response) => {
                        DATA = response.data;

                        this.$log.warn('saliendo de service_json_movistar_encode',DATA)
                        this.$log.warn('antes de entrar a service_token_movistar')

                        this.$api
                            .service_token_movistar({post: null})
                            .then((response2) => {

                                TOKEN = response2.data;
                                this.$log.warn('saliendo de service_token_movistar',TOKEN)
                                if (DATA != "" && TOKEN != "") {
                                    var domain = "https://wstcb-mobile.terra.com/wstcb/Detect.asmx/WhoTime";
                // var domain = "https://e823a188-81c2-4f7b-92d5-4c8a29cab4c5.mock.pstmn.io/terra";
                 //var domain = "https://c6b88a8a-7419-4d6c-9f7f-bd5498979eb1.mock.pstmn.io/terrax";
                                    var url = domain + "?data=" + DATA + "&ttkn=" + TOKEN;
                                    //var url= domain;
                                    this.$log.warn('URL de envio',url);

                                    $.ajax({
                                        type: "GET",
                                        url: url,
                                        contentType: "application/x-www-form-urlencoded",
                                        dataType: "JSONP",
                                        success: function (result) {
                                            console.log(result)
                                            var msg = "";
                                            var e1 = "";
                                            var e2 = "";
                                            /*msg = "hola";
                                            // e1="hpZART5L5nbUKIIajH9n3Q==";
                                            // e2="dKDJ5Wzb76x60Tm9klTwhg==";*/
                                            if (result.RESPONSE[0].MESSAGE != undefined)
                                                msg = result.RESPONSE[0].MESSAGE;
                                            if (result.RESPONSE[0].E1 != undefined)
                                                e1 = result.RESPONSE[0].E1;
                                            if (result.RESPONSE[0].E2 != undefined)
                                                e2 = result.RESPONSE[0].E2;


                                            thisinterno.$api.service_json_movistar_decode({
                                                "data": {
                                                    "e1": e1,
                                                    "e2": e2,
                                                }
                                            }).then((responseDecodeMovistar) => {
                                                console.log("decode:",responseDecodeMovistar);

                                                if (responseDecodeMovistar.data.response ==="400") {
                                                    localStorage.setItem("isTelefonoValid", "false");
                                                    localStorage.setItem("header", false);
                                                    thisinterno.movistarConfirm();
                                                    return;

                                                }

                                                if (responseDecodeMovistar.data.data.length > 0) {

                                                    //Telefono
                                                    localStorage.setItem(
                                                        "telefono_suscribir",
                                                        responseDecodeMovistar.data.data[0]
                                                    );

                                                    thisinterno.telefono = parseInt(
                                                        responseDecodeMovistar.data.data[0], 10
                                                    );

                                                    //Pin
                                                    thisinterno.pin = parseInt(
                                                        responseDecodeMovistar.data.data[1], 10
                                                    );

                                                    //Completar 0 del pin
                                                    if (thisinterno.pin.toString().length == 3) {
                                                        thisinterno.pin = "0" + thisinterno.pin;
                                                    }

                                                    //Completar 0 del pin
                                                    if (thisinterno.pin.toString().length == 2) {
                                                        thisinterno.pin = "0" + "0" + thisinterno.pin;
                                                    }

                                                    //Completar 0 del pin
                                                    if (thisinterno.pin.toString().length == 1) {
                                                        thisinterno.pin = "0" + "0" + "0" + thisinterno.pin;
                                                    }

                                                    localStorage.setItem("header", true);
                                                    localStorage.setItem("isTelefonoValid", "true");
                                                    //TODO analizar si el selected portal pasarela es necesario
                                                    localStorage.setItem("selectedPortalPasarela", "");
                                                    //thisinterno.$log.warn('tele ',[thisinterno.telefono])
                                                    if (typeof thisinterno.$route.query.operador !== "undefined") {
                                                        if (thisinterno.telefono != "" && thisinterno.pin != "") {
                                                            thisinterno.movistarConfirm();
                                                        }
                                                    }
                                                } else {
                                                    console.log("modan nuevo numero");
                                                    localStorage.setItem("isTelefonoValid", "false");
                                                    localStorage.setItem("header", false);
                                                    this.modalPinInputMsisdn = true;
                                                }

                                            }).catch((error) => {
                                                console.log(error);
                                            });
                                        },
                                        complete: function (result) {
                                        },
                                        error: function (e) {
                                            console.log("aaaca es error");
                                            console.log(e);
                                        },
                                    });
                                    this.isPagoUrlLandingModalVisible = false;
                                    this.isLoadingPagoUrl = false;
                                    this.service_ip_entel = false;
                                }
                            });
                    });
            }
        },

        movistarConfirm() {
            this.$log.warn('movistarConfirm');
            if (typeof this.$route.query.operador !== "undefined"
                && this.telefono != "" && this.pin != "") {

                    //this.msisdnEntel
                //Asignar numero identificado a telefono
                this.msisdnEntel = this.telefono;
                //Mostrar modal de confirmacion
                if (this.msisdnEntel.toString().length > 8){
                    this.modalInitMovistarHeader = true;

                }else {
                    localStorage.setItem("telefono_suscribir","");
                    this.isPagoUrlLandingModalVisible = false;
                }
            } else {

                if (localStorage.getItem("header")==="false") {
                    this.modalPinInputMsisdn = true;

                } else {
                   return false;
                }
                return false;
            }

        },
        loadDataUser() {
            // TODO: manejar cuando no existe el video
            if (!this.site.didLoadUser) {
                // Aún está cargando.
                setTimeout(() => {
                    this.loadDataUser();
                }, 100);
                return false;
            }
            if (!this.site.didLoadUser) {
                /*console.log(
                  getCategoriaDeProducto(this.portal, this.productoSeleccionado)
                );*/
                this.$router.push({
                    name: "curso",
                    params: {
                        guid: getCategoriaDeProducto(this.portal, this.productoSeleccionado)
                            .guid,
                    },
                });
                return false;
            }
            // TODO: manejar cuando no existe el video
            if (!this.site.didLoadUserCompras) {
                // Aún está cargando.
                setTimeout(() => {
                    this.loadDataUser();
                }, 100);
                return false;
            }

        },
        start() {
            this.$log.warn('start')
            this.cargar_pasarela(
                this.productoSeleccionado == false
                    ? this.$route.params.id
                    : this.productoSeleccionado
            );
            this.isVisible = true;
        },
        LandingOperador() {
            let queryOperador = this.operador_suscribir;
            this.portalPasarelas.forEach((pasarelas) => {
                if (
                    pasarelas.pasarela.is_movil == 1 &&
                    queryOperador.toLowerCase() != "" &&
                    queryOperador.toLowerCase() ==
                    pasarelas.pasarela.pasarela.toLowerCase()
                ) {
                    if (
                        this.selectedPortalPasarela.pasarela.pasarela.toLowerCase() ==
                        queryOperador.toLowerCase()
                    ) {
                        return false;
                    }
                    this.$log.warn('que pasarela es - ',pasarelas.pasarela.pasarela)
                    this.isVisible = true;
                    this.setPortalPasarela(pasarelas, event);
                }
            });
        },
        async LandingsPreWorks(pinPreWork) {

            let empelloToken = ""

            this.$log.warn('this.operador_suscribir ',this.operador_suscribir);

            /* Se evita toda la logica realizada hasta ahora (Registro -- Login y pago) y se encamina al usuario al flujo necesario (Landing Pre-work)*/
            let preworkData = {
                idPasarela: this.selectedPortalPasarela.pasarela.id,
                operador_suscribir: this.operador_suscribir,
                network:{
                    "operador":"movistar",
                    "g_id":"11"
                },
                utm_source: localStorage.getItem("utm_source"),
                utm_medium: localStorage.getItem("utm_medium"),
                utm_campaign: localStorage.getItem("utm_campaign"),
                deviceName:
                    this.selectedPortalPasarela.pasarela.pasarela == "Movistar"
                        ? "Huawei"
                        : "",
                deviceId: 1587, //Este dato es inventado
                idProduct: this.producto.id,
                header: localStorage.getItem("header"),
                msisdn: localStorage.getItem("telefono_suscribir"),
                pin: typeof pinPreWork !== "undefined" ? pinPreWork : "",
                empelloFraudStopToken: empelloToken,
            };

            this.$log.warn('preworkData ',preworkData);
            this.$store
                .dispatch("landingPreWork", preworkData)
                .then((response) => {
                    //this.test = response
                    //CASO MOVISTAR
                    if (this.selectedPortalPasarela.pasarela.pasarela.toLowerCase() == "movistar") {
                        //Solicito Pin
                        if (response.status == 202) {
                            this.isMovilModalVisible = false;
                            //this.isPinModalVisible = true;
                            this.modalPinInputPin = true;

                        } else if (response.status == 201) {
                            this.isMovilModalVisible = false;
                            //this.isPinModalVisible = true;
                            this.modalPinInputPin = true;
                            this.isLoadingPagoMovilPinUrl = false;
                            this.pinMessage = response.message;

                        } else if (response.status == 200) {
                            this.aux_1=response.data.id;
                            this.aux_2=response.data.producto;
                            this.$log.warn('id compra 1 ' + this.aux_1)
                            this.vistaFelicitaciones();
                            /*this.$router.push({
                                name: "CheckoutFinish",
                                params: {
                                    pasarela: "preworklandingoperador",
                                    id_compra: response.data.id,
                                    estado: "aprobado",
                                    productoLanding: response.data.producto,
                                }
                            });*/

                        } else if (response.status == 16) {

                            this.isPagoUrlLandingModalVisible = false;
                            window.location.href = response.url_redirect;

                        } else if (response.status == 1) {

                            this.isPagoUrlLandingModalVisible = true;
                            this.isPagoLandingMessage = response.message;

                        }
                    }

                })
                .catch((error) => {
                    if (
                        error.data.status != 1 &&
                        error.data.status != 16 &&
                        error.data.status != 202 &&
                        error.data.status != 201 &&
                        error.data.status != 200
                    ) {
                    this.$log.warn('Error ',error.data.message);
                        //Caso general
                        //this.isPagoUrlLandingModalVisible = true;
                        //this.isPagoLandingMessage = error.data.message;
                        this.movistar_error_modal = true;
                        //this.suscrib_felicitaciones = true;
                        setTimeout(() => {
                            //Caso Movistar
                            this.isPagoUrlLandingModalVisible = false;
                            this.isPagoLandingMessage = "";
                        }, 4500);
                    }
                });
        },
        operadorPreDetect: function () {
            this.$log.warn('operadorPreDetect')
            this.$api
                .operadorPreDetect()
                .then((response) => {
                    if (response.data.status == "200") {
                        this.operador_suscribir = response.data.operador;
                    } else {
                        this.operador_suscribir = "";
                    }
                })
                .catch((error) => {
                    this.operador_suscribir = "";
                });
        },
         openConfirmUser() {
            if (this.telefono != "") {
                this.confirm_of_user = true
            }
        },
        modalFelicitaciones() {
            if (this.telefono != "") {
                this.suscrib_felicitaciones = true
            }
        },
        vistaFelicitaciones() {
            this.$log.warn('felicitaciones')
                this.$log.warn('felicitaciones 2')
                    if (typeof this.$route.query.operador !== "undefined"
                && this.telefono != "" && this.pin != "") {
                //Asignar numero identificado a telefono
                this.msisdnEntel = this.telefono;
                     window.location.href = "/comprar/gmovistar/felicitaciones/"+this.$route.params.curso+"/"+this.$route.params.id+"/"+this.msisdnEntel;
                }else {
                    window.location.href = "/comprar/gmovistar/felicitaciones/"+this.$route.params.curso+"/"+this.$route.params.id+"/"+this.msisdnEntel;
                }
        },
        accederServicio(){
            window.location.href = "https://cms.topclass.academy/thinkific/auth";
        },
        volverCancelarSalir(){
            window.location.href = "/curso/"+this.$route.params.curso;
        },
    },
    mounted() {

        this.$log.warn('mounted1')
        if (this.portal.productos_portal) {
            this.$log.warn('mounte2')
            this.start();
        }

        if (typeof this.$route.query.operador !== "undefined") {
            this.$log.warn('mounted3')
            this.operadorPreDetect();
        }
        this.$log.warn('mounted4')

         setInterval(() => {
            this.$log.warn('mounted5')
            this.LandingOperador();
        }, 1000);

        let postData = {
            event: "Checkout " + this.portal.nombre,
            curso: "Curso " + this.categoria.autor,
        };
        this.montoTotal = this.producto.precio;

        //CHECKOUT
        dataLayer.push({
            event: "checkout",
            ecommerce: {
                checkout: {
                    actionField: {step: 1, option: ""},
                    products: [
                        {
                            name: this.producto.producto,
                            id: this.producto.id,
                            price: this.producto.precio,
                            category: this.categoria.categoria,
                            quantity: 1,
                        },
                    ],
                },
            },
        });

    },
    created() {
        this.loadDataUser();
        document.head.querySelector("meta[name=description]").content =
            this.$route.params.suscripcion != "suscripcion"
                ? this.curso.productos_categorias[0].categorias_productos[0].descripcion
                : this.portal.descripcion;

        this.operadorParametro = this.$route.query.operador;

        if (typeof this.user.telefono !== "undefined" && this.user.telefono != "") {
            this.telefono = this.user.telefono;
        }

        localStorage.setItem(
            "telefono_suscribir",
            typeof this.user.telefono !== "undefined" && this.user.telefono != ""
                ? this.user.telefono
                : ""
        );
        localStorage.setItem("header", false);
    },
};
</script>
